import PropTypes from 'prop-types';
import React from 'react';
import { Provider as CommunityProvider } from '../../../contexts/CommunityContext';
import UserIcon from './UserIcon/UserIcon';

import './UserIconList.scss';

export default class UserIconList extends React.PureComponent {
    constructor(props) {
        super();
    }

    static propTypes = {
        /**
         * css class that would override the original style
         */
        className: PropTypes.string,
        /**
         * list of user that are going to be displayed
         */
        userList: PropTypes.array.isRequired,
        /**
         * number of user that is going to be displayed per row
         */
        userPerRow: PropTypes.number,
        /**
         * should VIP badge be shown if applicable
         */
        showVipBadge: PropTypes.bool,
    };

    static defaultProps = {
        className: '',
        userList: [],
        userPerRow: 4,
        showVipBadge: true,
    };

    render() {
        const { userList, className, userPerRow, showVipBadge } = this.props;
        const widthStyle = { width: `${100 / userPerRow}%` };

        if (!userList || userList.length < 1) {
            return null;
        }

        return (
            <div className={`component-Users-UserIconList ${className}`}>
                <CommunityProvider>
                    {userList.map((userItem, index) => (
                        <UserIcon
                            widthStyle={widthStyle}
                            user={userItem.user}
                            key={`user-${index}`}
                            groupMemberType={userItem.groupMemberType}
                            showVipBadge={showVipBadge}
                        />
                    ))}
                </CommunityProvider>
            </div>
        );
    }
}
